module.exports = "<div class=\"alert alert-warning\" ng-if=$ctrl.isMessageVisible><span><l10n>The seat/s selected for the traveller</l10n></span><span ng-bind=::$ctrl.previousTravellerFullName></span> <span><l10n>has been removed. Please select the seat/s again</l10n>.</span></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/traveller/discard-seat-on-traveller-change/discard-seat-on-traveller-change.html
// module id = 3611
// module chunks = 0